import React, { useState } from 'react';
import PageHero from './PageHero';
import './Industries.css';

const Industries = () => {
  const [selectedIndustry, setSelectedIndustry] = useState(null);

  const industries = [
    {
      id: 1,
      title: 'Financial Services & Banking',
      icon: 'fas fa-university',
      image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&q=80',
      description: 'Secure banking and financial operations with AI-driven cybersecurity and digital transformation expertise.',
      technologyProducts: [
        'ShieldEx - AI-powered threat detection for financial transactions',
        'AWS/Azure Cloud Infrastructure for scalable banking systems',
        'Splunk/Power BI for real-time financial analytics',
        'GenAI Platforms (OpenAI, Anthropic) for automated compliance reporting',
        'Snowflake/Databricks for data warehousing and analytics',
        'Kubernetes for containerized financial applications'
      ],
      challenges: [
        'Regulatory compliance and risk management',
        'Real-time threat detection',
        'Legacy system modernization',
        'Data protection and privacy'
      ],
      solutions: [
        'ShieldEx cybersecurity for financial data protection',
        'GenAI for automated report generation and risk analysis',
        'Data engineering for real-time analytics and reporting',
        'Cloud migration for scalable operations',
        'Compliance automation and reporting',
        'Expert fintech talent placement'
      ],
      gradient: 'linear-gradient(135deg, #667eea, #764ba2)'
    },
    {
      id: 2,
      title: 'Healthcare',
      icon: 'fas fa-heartbeat',
      image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1200&q=90&auto=format',
      description: 'Protecting patient data and enabling digital health innovation with intelligent security solutions.',
      technologyProducts: [
        'ShieldEx - Healthcare data protection and HIPAA compliance',
        'Epic/Cerner EHR integration solutions',
        'Azure Health Data Services for secure cloud storage',
        'GenAI for clinical documentation and research automation',
        'DICOM-compliant imaging systems',
        'FHIR-based interoperability platforms'
      ],
      challenges: [
        'HIPAA and healthcare compliance',
        'Medical device security',
        'Telemedicine infrastructure',
        'Electronic health records protection'
      ],
      solutions: [
        'Healthcare-specific cybersecurity frameworks',
        'GenAI for clinical documentation and research',
        'Data engineering for patient analytics and insights',
        'Secure cloud infrastructure for health data',
        'Digital transformation for hospitals',
        'Healthcare IT specialists'
      ],
      gradient: 'linear-gradient(135deg, #f093fb, #f5576c)'
    },
    {
      id: 3,
      title: 'Aerospace & Defense',
      icon: 'fas fa-plane',
      image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&q=80',
      description: 'Safeguarding critical defense infrastructure and supporting aerospace innovation with advanced security.',
      technologyProducts: [
        'ShieldEx - Mission-critical cybersecurity for defense systems',
        'Azure Government and AWS GovCloud for classified data',
        'Siemens NX/Catia for aerospace design and simulation',
        'Digital Twin platforms (Azure Digital Twins)',
        'SCADA/ICS security solutions',
        'PLM systems for aerospace manufacturing'
      ],
      challenges: [
        'Mission-critical system protection',
        'Supply chain security',
        'IT/OT convergence',
        'Compliance with defense standards'
      ],
      solutions: [
        'Zero-trust architecture implementation',
        'Secure cloud and edge computing',
        'Digital twin and simulation expertise',
        'Aerospace engineering talent'
      ],
      gradient: 'linear-gradient(135deg, #4facfe, #00f2fe)'
    },
    {
      id: 4,
      title: 'Manufacturing',
      icon: 'fas fa-industry',
      image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=1200&q=90&auto=format',
      description: 'Securing Industrial IoT and enabling smart manufacturing with AI-powered cybersecurity.',
      technologyProducts: [
        'ShieldEx - Industrial IoT and OT security',
        'Siemens MindSphere for Industrial IoT',
        'Azure IoT Hub for connected manufacturing',
        'Tableau/Power BI for manufacturing analytics',
        'SAP ERP and MES integration',
        'AWS IoT Greengrass for edge computing'
      ],
      challenges: [
        'OT/IT security convergence',
        'Supply chain resilience',
        'Industry 4.0 transformation',
        'Operational technology protection'
      ],
      solutions: [
        'IoT and industrial cybersecurity',
        'Digital manufacturing platforms',
        'Predictive maintenance systems',
        'Manufacturing technology experts'
      ],
      gradient: 'linear-gradient(135deg, #fa709a, #fee140)'
    },
    {
      id: 5,
      title: 'High-Tech & Technology',
      icon: 'fas fa-microchip',
      image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&q=80',
      description: 'Partnering with tech companies to accelerate innovation while maintaining robust security postures.',
      technologyProducts: [
        'ShieldEx - API and cloud-native security',
        'Kubernetes and Docker for containerization',
        'LangChain/ LlamaIndex for GenAI frameworks',
        'AWS/GCP/Azure cloud platforms',
        'GitHub Actions, GitLab CI/CD for DevSecOps',
        'Databricks/Apache Spark for big data processing',
        'TensorFlow/PyTorch for ML development'
      ],
      challenges: [
        'Rapid innovation cycles',
        'API and cloud security',
        'DevSecOps implementation',
        'Scalable infrastructure'
      ],
      solutions: [
        'GenAI integration and LLM deployment',
        'Cloud-native security solutions',
        'Data engineering for scalable data platforms',
        'CI/CD pipeline security',
        'AI/ML platform development',
        'Full-stack engineering talent'
      ],
      gradient: 'linear-gradient(135deg, #30cfd0, #330867)'
    },
    {
      id: 6,
      title: 'Energy & Utilities',
      icon: 'fas fa-bolt',
      image: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=800&q=80',
      description: 'Protecting critical energy infrastructure and enabling smart grid transformation.',
      technologyProducts: [
        'ShieldEx - SCADA and ICS cybersecurity',
        'Siemens EnergyIP for smart grid management',
        'OSIsoft PI System for operational data',
        'Azure Energy Management Platform',
        'AWS IoT Core for smart meter integration',
        'Predictive analytics platforms for grid optimization'
      ],
      challenges: [
        'Grid cybersecurity',
        'Renewable energy integration',
        'Operational resilience',
        'Regulatory compliance'
      ],
      solutions: [
        'SCADA and ICS security',
        'Energy management systems',
        'Smart grid transformation',
        'Energy sector technology professionals'
      ],
      gradient: 'linear-gradient(135deg, #a8edea, #fed6e3)'
    },
    {
      id: 7,
      title: 'Government & Public Sector',
      icon: 'fas fa-landmark',
      image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80',
      description: 'Enabling secure digital government services and protecting national critical infrastructure.',
      technologyProducts: [
        'ShieldEx - Government-grade cybersecurity',
        'Azure Government and AWS GovCloud',
        'ServiceNow for government service management',
        'Salesforce Government Cloud',
        'Microsoft 365 Government',
        'Identity and access management (IAM) solutions'
      ],
      challenges: [
        'Citizen data protection',
        'Legacy system modernization',
        'Inter-agency collaboration',
        'National security compliance'
      ],
      solutions: [
        'Government-grade cybersecurity',
        'Citizen service platforms',
        'Cloud migration for agencies',
        'Public sector IT expertise'
      ],
      gradient: 'linear-gradient(135deg, #667eea, #764ba2)'
    },
    {
      id: 8,
      title: 'Retail & E-commerce',
      icon: 'fas fa-shopping-cart',
      image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80',
      description: 'Securing customer transactions and enabling seamless digital commerce experiences.',
      technologyProducts: [
        'ShieldEx - PCI DSS compliant payment security',
        'Shopify Plus, Magento, WooCommerce platforms',
        'GenAI chatbots for customer service (LangChain)',
        'AWS/GCP commerce solutions',
        'Stripe, PayPal payment gateway integration',
        'Tableau for retail analytics and insights'
      ],
      challenges: [
        'Payment data security',
        'E-commerce platform protection',
        'Customer data privacy',
        'Omnichannel integration'
      ],
      solutions: [
        'GenAI for personalized shopping experiences and chatbots',
        'PCI DSS compliance solutions',
        'Secure e-commerce platforms',
        'Digital customer experience',
        'E-commerce development talent'
      ],
      gradient: 'linear-gradient(135deg, #f093fb, #f5576c)'
    }
  ];

  const closeModal = () => {
    setSelectedIndustry(null);
    document.body.style.overflow = 'auto';
  };

  const openModal = (industry) => {
    setSelectedIndustry(industry);
    document.body.style.overflow = 'hidden';
  };

  return (
    <>
      <PageHero
        sectionId="industries"
        title="Industries We Serve"
        subtitle="Industry Expertise"
        description="Choose a partner with intimate knowledge of your industry and first-hand experience of defining its future through AI-driven security, digital transformation, and expert talent."
        image="https://images.unsplash.com/photo-1552664730-d307ca884978?w=1600&q=80"
        gradient="linear-gradient(135deg, rgba(102, 126, 234, 0.9), rgba(118, 75, 162, 0.9))"
      />
      <section id="industries" className="industries">
      <div className="container">
        <div className="industries-grid">
          {industries.map((industry) => (
            <div 
              key={industry.id} 
              className="industry-card"
              onClick={() => openModal(industry)}
              style={{ cursor: 'pointer' }}
            >
              <div className="industry-image-wrapper">
                <div 
                  className="industry-image" 
                  style={{ backgroundImage: `url(${industry.image})` }}
                >
                  <div className="industry-image-overlay" style={{ background: industry.gradient }}></div>
                </div>
              </div>
              <div className="industry-header">
                <div className="industry-icon" style={{background: industry.gradient}}>
                  <i className={industry.icon}></i>
                </div>
                <h3>{industry.title}</h3>
              </div>
              <p className="industry-description">{industry.description}</p>
              
              <div className="industry-details-preview">
                <div className="detail-preview">
                  <i className="fas fa-exclamation-triangle"></i>
                  <span>{industry.challenges.length} Key Challenges</span>
                </div>
                <div className="detail-preview">
                  <i className="fas fa-lightbulb"></i>
                  <span>{industry.solutions.length} Solutions</span>
                </div>
              </div>
              
              <div className="industry-cta">
                Click for Details
                <i className="fas fa-arrow-right"></i>
              </div>
            </div>
          ))}
        </div>

        <div className="industries-cta-section">
          <div className="cta-content">
            <h3>Ready to Transform Your Industry?</h3>
            <p>
              Let's discuss how Rivontrix can help address your industry-specific challenges 
              with our AI-driven cybersecurity, digital transformation, and talent solutions.
            </p>
            <a 
              href="#contact" 
              className="btn btn-primary"
              onClick={(e) => {
                e.preventDefault();
                const event = new CustomEvent('sectionChange', { detail: 'contact' });
                window.dispatchEvent(event);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              Get in Touch
            </a>
          </div>
        </div>
      </div>
    </section>

    {selectedIndustry && (
      <div className="industry-modal-overlay" onClick={closeModal}>
        <div className="industry-modal" onClick={(e) => e.stopPropagation()}>
          <button className="modal-close" onClick={closeModal}>
            <i className="fas fa-times"></i>
          </button>
          
          <div className="modal-header">
            <div 
              className="modal-image" 
              style={{ backgroundImage: `url(${selectedIndustry.image})` }}
            >
              <div className="modal-image-overlay" style={{ background: selectedIndustry.gradient }}></div>
            </div>
            <div className="modal-title-section">
              <div className="modal-icon" style={{background: selectedIndustry.gradient}}>
                <i className={selectedIndustry.icon}></i>
              </div>
              <h2>{selectedIndustry.title}</h2>
              <p className="modal-subtitle">{selectedIndustry.description}</p>
            </div>
          </div>

          <div className="modal-content">
            <div className="modal-section">
              <h3>
                <i className="fas fa-cogs"></i>
                Technology Products Used
              </h3>
              <ul className="products-list">
                {selectedIndustry.technologyProducts.map((product, idx) => (
                  <li key={idx}>
                    <i className="fas fa-check-circle"></i>
                    {product}
                  </li>
                ))}
              </ul>
            </div>

            <div className="modal-section">
              <h3>
                <i className="fas fa-exclamation-triangle"></i>
                Key Challenges
              </h3>
              <ul className="challenges-list">
                {selectedIndustry.challenges.map((challenge, idx) => (
                  <li key={idx}>
                    <i className="fas fa-circle"></i>
                    {challenge}
                  </li>
                ))}
              </ul>
            </div>

            <div className="modal-section">
              <h3>
                <i className="fas fa-lightbulb"></i>
                Our Solutions
              </h3>
              <ul className="solutions-list">
                {selectedIndustry.solutions.map((solution, idx) => (
                  <li key={idx}>
                    <i className="fas fa-check-circle"></i>
                    {solution}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="modal-footer">
            <a 
              href="#contact" 
              className="btn btn-primary" 
              onClick={(e) => {
                e.preventDefault();
                closeModal();
                const event = new CustomEvent('sectionChange', { detail: 'contact' });
                window.dispatchEvent(event);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              Get in Touch
              <i className="fas fa-arrow-right"></i>
            </a>
          </div>
        </div>
      </div>
    )}
    </>
  );
};

export default Industries;

